// recieve data biometric
export const PEN_VF = 'PEN_VF'
export const PONG = 'PONG'
export const NEW_DEVICE = 'NEW_DEVICE'
export const COMPLETED_REVIEW = 'COMPLETED_REVIEW'